// Service Worker registration with automatic updates

export function register() {
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service workers not supported');
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Registered:', registration.scope);

        // Check for updates every hour
        setInterval(() => {
          registration.update().catch((error) => {
            console.error('[SW] Update check failed:', error);
          });
        }, 60 * 60 * 1000);

        // Check for updates when the page becomes visible
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) {
            registration.update().catch((error) => {
              console.error('[SW] Update check failed:', error);
            });
          }
        });

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          if (!newWorker) {
            console.warn('[SW] No installing worker found during update');
            return;
          }
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available - activate immediately without reload
              console.log('[SW] Update available, activating new service worker');
              
              // Check if the worker is still in a valid state before posting message
              if (newWorker.state === 'installed') {
                try {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                } catch (error) {
                  console.error('[SW] Failed to skip waiting:', error);
                }
              }
            }
          });
        });

        // Log when new service worker takes control (no reload)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('[SW] New service worker active');
        });
      })
      .catch((error) => {
        console.error('[SW] Registration failed:', error);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[SW] Error during unregister:', error);
      });
  }
}